export default "__VITE_ASSET__C41UI7pM__"